import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import http from 'helpers/requests';
import { CgFilterSelect } from 'modules/Common/ui/CgFilterDropdown';

// Declarant supplier picker on the standard CgFilterSelect (Radix popover,
// dialog-aware portal). Raw-value API:
//   selectedSupplier    — current value (supplier _id string)
//   setSelectedSupplier — called with the new _id string (or '' when cleared)
//   disabled            — optional
export default function CgSupplierSelect({ selectedSupplier, setSelectedSupplier, disabled }) {
  const { t } = useTranslation('common');
  const { data: options = [], isLoading } = useQuery({
    queryKey: ['suppliers'],
    queryFn: async () => {
      const response = await http.get('/suppliers/declarant');
      return response.data.suppliers.map((s) => ({ value: s._id, label: s.name }));
    },
  });

  return (
    <CgFilterSelect
      options={options}
      value={selectedSupplier || null}
      onChange={(val) => setSelectedSupplier?.(val ?? '')}
      disabled={disabled || isLoading}
      placeholder={
        isLoading
          ? t('common:supplierSelect.loadingSuppliers', 'Loading suppliers…')
          : t('common:supplierSelect.selectASupplierRequired', 'Select a Supplier *')
      }
      // Entity picker — always searchable, regardless of list size.
      searchable
    />
  );
}
